import { render, staticRenderFns } from "./self-developed-products.vue?vue&type=template&id=27b9c685&scoped=true"
import script from "./self-developed-products.vue?vue&type=script&lang=js"
export * from "./self-developed-products.vue?vue&type=script&lang=js"
import style0 from "./self-developed-products.vue?vue&type=style&index=0&id=27b9c685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b9c685",
  null
  
)

export default component.exports